import { AutocompleteBase } from '@shared/components';
import { useGetUsers } from '@shared/graphql/hooks/users/useGetUsers';
import { User } from '@shared/types/user';
import { compact } from 'lodash';
import { useState } from 'react';

type UserOption = {
  label: string;
  id: string;
};

export type PostingUserAutocompleteProps = {
  organizationId: string | null;
  placeholder?: string;
  onChange: (userId: string | null) => void;
  className?: string;
};

export function PostingUserAutocomplete({
  organizationId,
  onChange,
  placeholder,
  className,
}: PostingUserAutocompleteProps) {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { users } = useGetUsers({
    organizationIds: compact([organizationId]),
    searchTerm,
  });

  const options = toOptions(users);

  return (
    <AutocompleteBase
      className={className}
      blurOnSelect
      options={options}
      placeholder={placeholder ?? 'Select account'}
      onInputChange={(_, query) => {
        setSearchTerm(query);
      }}
      onChange={(_, value) => {
        const selectedOption = value as UserOption | null;
        onChange(selectedOption?.id ?? null);
      }}
    />
  );
}

const toOptions = (users: User[]): UserOption[] => {
  const mappedUsers = users.map((user) => ({
    label: user.email,
    id: user.id,
  }));

  return mappedUsers.filter((u) => u.label && u.id) as UserOption[];
};
